import PermissionsBase from './permissions-base';

export default class PermissionsEqual extends PermissionsBase {
  compute([level]) {
    return this.permissions.equal(level);
  }
}
